// extracted by mini-css-extract-plugin
export var container = "_57-0";
export var fallback = "_57-5";
export var fallbackIcon = "_57-6";
export var hidden = "_57-2";
export var image = "_57-3";
export var loaded = "_57-4";
export var placeholder = "_57-1";